import { BASE_URL } from '../../Resources/Api';
import axios from "axios";

// const authToken = localStorage.getItem('accessToken');

// Get User List
export function attStatusAction(
   cardNumber,
   setCardNumber,
   setAssignAsset,
   setAttModalOpen,
   setMessage,
   cardInputRef,
   scanInputRef,
   authToken
) {
   return async function (dispatch) {
      setCardNumber('')
      axios({
         method: 'POST',
         headers: {
            Authorization: 'Bearer ' + authToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         url: BASE_URL + 'att-status',
         data: {
            "card_no": cardNumber
         }
      })
         .then(function (response) {
            if (response.status === 200) {
               if (response.data.status === true) {
                  dispatch({
                     type: 'GET_ATT_STATUS',
                     payload: response.data.data
                  })
                  // console.log(response.data.data.asset.assign_status);
                  const assetListFromAsset = response.data.data.asset.map(item => {
                     return {
                        assetListId: item.asset_list.id,
                        assetQr: item.asset_list.qr_code,
                        assetName: item.asset_list.asset.name,
                        assignStatus: item.assign_status
                     }
                  })
                  const assetListFromPost = response.data.data.post.post_asset.map(item => {
                     return {
                        assetListId: '',
                        assetQr: '',
                        assetName: item.asset.name,
                        assignStatus: 'N'
                     }
                  })
                  response.data.data.asset.length > 0 ?
                     setAssignAsset(assetListFromAsset) :
                     setAssignAsset(assetListFromPost)
                  setAttModalOpen(true)
                  scanInputRef.current.focus();
               } else {
                  setMessage({
                     status: true,
                     type: "error",
                     message: response.data.message
                  })
                  setTimeout(() => {
                     setMessage({
                        status: false,
                     })
                  }, 1500);
                  cardInputRef.current.focus();
               }
            } else {
               setMessage({
                  status: true,
                  type: "error",
                  message: response.data.message
               })
               setTimeout(() => {
                  setMessage({
                     status: false,
                  })
               }, 1500);
               cardInputRef.current.focus();
            }
         })
         .catch(function (error) {
            setMessage({
               status: true,
               type: "error",
               message: 'Something went wrong. Please try again.'
            })
            setTimeout(() => {
               setMessage({
                  status: false
               })
            }, 1500);
            // cardInputRef.current.focus();
            console.log(error);
         });
   }
}

export function findAssetAction(assetQr, setAssetQr, assignAsset, setAssignAsset, setMessage, scanInputRef, authToken) {
   return async function (dispatch) {
      setAssetQr('')
      axios({
         method: 'POST',
         headers: {
            Authorization: 'Bearer ' + authToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         url: BASE_URL + 'find-asset',
         data: {
            "assetQr": assetQr
         }
      })
         .then(function (response) {
            // console.log('Assets Action=================', response.data);
            if (response.status === 200) {
               if (response.data.status === true) {
                  // setAssignAsset([
                  //    ...assignAsset,
                  //    {
                  //       assetListId: response.data.data.id,
                  //       assetQr: response.data.data.qr_code,
                  //       assetName: response.data.data.asset.name
                  //    }
                  // ]);

                  const assetsToMatch = assignAsset.slice();
                  const findAsset = assignAsset.filter(item => item.assetName === response.data.data.asset.name);
                  const updateAssetWith = findAsset.map(item => {
                     return {
                        assetListId: response.data.data.id,
                        assetQr: response.data.data.qr_code,
                        assetName: item.assetName,
                        assignStatus: 'A'
                     }
                  })
                  let updateAsset = updateAssetWith[0];
                  let clone = assetsToMatch;
                  const index = clone.findIndex((obj) => obj.assetName === updateAsset.assetName);
                  if (index !== -1) clone[index] = updateAsset;
                  setAssignAsset(clone)

                  // console.log("Scan action", updateAsset);

                  dispatch({
                     type: 'FIND_ASSET',
                     payload: response.data.data
                  });
                  scanInputRef.current.focus();
               } else {
                  setMessage({
                     status: true,
                     type: "error",
                     message: response.data.message
                  })
                  setTimeout(() => {
                     setMessage({
                        status: false,
                     })
                  }, 1500);
               }
            }
         })
         .catch(function (error) {
            setMessage({
               status: true,
               type: "error",
               message: 'Something went wrong. Please try again.'
            })
            setTimeout(() => {
               setMessage({
                  status: false
               })
            }, 1500);
            console.log(error);
         });
   }
}

// Save Action
export function saveAttendance(
   employeeId,
   postId,
   shiftId,
   assignAssetToSubmit,
   setAttModalOpen,
   setMessage,
   cardInputRef,
   scanInputRef,
   authToken
) {
   return async function (dispatch) {
      console.log({
         emp_id: employeeId,
         device_id: 1,
         post_id: postId,
         shift_id: shiftId,
         assigned_asset: assignAssetToSubmit
      });

      axios({
         method: 'POST',
         headers: {
            Authorization: 'Bearer ' + authToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         url: BASE_URL + 'attendance',
         data: {
            emp_id: employeeId,
            device_id: 1,
            post_id: postId,
            shift_id: shiftId,
            assigned_asset: assignAssetToSubmit
         }
      })
         .then(function (response) {
            // console.log('Banner Category Action=================', response.data);
            if (response.status === 200) {
               if (response.data.status === true) {
                  setAttModalOpen(false)
                  setMessage({
                     status: true,
                     type: "success",
                     message: response.data.message
                  })
                  setTimeout(() => {
                     setMessage({
                        status: false
                     })
                  }, 1500);
                  setTimeout(() => {
                     window.location.reload();
                  }, 1600)
                  cardInputRef.current.focus();
               } else {
                  setMessage({
                     status: true,
                     type: "error",
                     message: response.data.message
                  })
                  setTimeout(() => {
                     setMessage({
                        status: false
                     })
                  }, 1500);
                  scanInputRef.current.focus();
               }
            }
         })
         .catch(function (error) {
            setMessage({
               status: true,
               type: "error",
               message: 'Something went wrong. Please try again.'
            })
            setTimeout(() => {
               setMessage({
                  status: false
               })
            }, 1500);
            scanInputRef.current.focus();
            console.log(error);
         });
   }
}
